<template>
    <div class="right_container">
        <slot></slot>
    </div>
</template>

<style scoped>
    .right_container {
        flex: 0 1 100%;
        display: flex;
        flex-direction: column;
        max-width: calc(100% - 200px);
        padding: 24px 16px 24px 16px;
    }
</style>